import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';


@Component({
  selector: 'app-boolean-field[formGroup][propertyName]',
  templateUrl: './boolean-field.component.html',
  styles: [],
  standalone: false,
})
export class BooleanFieldComponent extends BaseFormComponent {

  @Input() subText?: string;
  @Input() values? = ['Y', 'N'];
  @Output() userInput? = new EventEmitter<string>();
  @Input() FIELD_SPACING: number

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  userAction(input: string) {
    this.userInput.emit(input);
  }



}
